// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Language, SummaryFiltersForm } from "../schema";
import { serialize_Language_internal, deserialize_Language_internal } from "./Language";

export function serialize_SummaryFiltersForm_internal(value: SummaryFiltersForm): unknown {
  return ((value: { audioFormFilter: boolean; languageFormFilter: Language[]; miabFormFilter: boolean; publicationDateFormFilter: number[]; qualityFormFilter: string[]; ratingFormFilter: number[]; sourceFormFilter: string[] }): unknown => {
    return {
      audioFormFilter: ((value: boolean): unknown => {
        return value;
      })(value["audioFormFilter"]),
      languageFormFilter: ((value: Language[]): unknown => {
        return value.map((value: Language): unknown => {
          return serialize_Language_internal(value);
        });
      })(value["languageFormFilter"]),
      miabFormFilter: ((value: boolean): unknown => {
        return value;
      })(value["miabFormFilter"]),
      publicationDateFormFilter: ((value: number[]): unknown => {
        return value.map((value: number): unknown => {
          return value;
        });
      })(value["publicationDateFormFilter"]),
      qualityFormFilter: ((value: string[]): unknown => {
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["qualityFormFilter"]),
      ratingFormFilter: ((value: number[]): unknown => {
        return value.map((value: number): unknown => {
          return value;
        });
      })(value["ratingFormFilter"]),
      sourceFormFilter: ((value: string[]): unknown => {
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["sourceFormFilter"]),
    };
  })(value);
}
export function serialize_SummaryFiltersForm(obj: SummaryFiltersForm): string {
  return renderJsonWithNumbersAsBigint(serialize_SummaryFiltersForm_internal(obj));
}
export function deserialize_SummaryFiltersForm_internal(value: unknown): ParserResult<SummaryFiltersForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    audioFormFilter: boolean;
    languageFormFilter: Language[];
    miabFormFilter: boolean;
    publicationDateFormFilter: number[];
    qualityFormFilter: string[];
    ratingFormFilter: number[];
    sourceFormFilter: string[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "audioFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/audioFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioFormFilter'.` };
    }
    const parsed_audioFormFilter = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/audioFormFilter]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["audioFormFilter"]);
    })();
    if (!parsed_audioFormFilter.success) {
      return { success: false, reason: parsed_audioFormFilter.reason };
    }
    if (!hasProp(value, "languageFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/languageFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'languageFormFilter'.` };
    }
    const parsed_languageFormFilter = ((): ParserResult<Language[]> => {
      return ((value: unknown): ParserResult<Language[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/languageFormFilter]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<Language> => {
          return deserialize_Language_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryFiltersForm/languageFormFilter]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["languageFormFilter"]);
    })();
    if (!parsed_languageFormFilter.success) {
      return { success: false, reason: parsed_languageFormFilter.reason };
    }
    if (!hasProp(value, "miabFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/miabFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'miabFormFilter'.` };
    }
    const parsed_miabFormFilter = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/miabFormFilter]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["miabFormFilter"]);
    })();
    if (!parsed_miabFormFilter.success) {
      return { success: false, reason: parsed_miabFormFilter.reason };
    }
    if (!hasProp(value, "publicationDateFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/publicationDateFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publicationDateFormFilter'.` };
    }
    const parsed_publicationDateFormFilter = ((): ParserResult<number[]> => {
      return ((value: unknown): ParserResult<number[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/publicationDateFormFilter]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<number> => {
          if (typeof value === "number") {
            return { success: true, value: value };
          }
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/publicationDateFormFilter]: '${value}' expected to be of type number.` };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryFiltersForm/publicationDateFormFilter]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["publicationDateFormFilter"]);
    })();
    if (!parsed_publicationDateFormFilter.success) {
      return { success: false, reason: parsed_publicationDateFormFilter.reason };
    }
    if (!hasProp(value, "qualityFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/qualityFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'qualityFormFilter'.` };
    }
    const parsed_qualityFormFilter = ((): ParserResult<string[]> => {
      return ((value: unknown): ParserResult<string[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/qualityFormFilter]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/qualityFormFilter]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryFiltersForm/qualityFormFilter]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["qualityFormFilter"]);
    })();
    if (!parsed_qualityFormFilter.success) {
      return { success: false, reason: parsed_qualityFormFilter.reason };
    }
    if (!hasProp(value, "ratingFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/ratingFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ratingFormFilter'.` };
    }
    const parsed_ratingFormFilter = ((): ParserResult<number[]> => {
      return ((value: unknown): ParserResult<number[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/ratingFormFilter]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<number> => {
          if (typeof value === "number") {
            return { success: true, value: value };
          }
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/ratingFormFilter]: '${value}' expected to be of type number.` };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryFiltersForm/ratingFormFilter]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["ratingFormFilter"]);
    })();
    if (!parsed_ratingFormFilter.success) {
      return { success: false, reason: parsed_ratingFormFilter.reason };
    }
    if (!hasProp(value, "sourceFormFilter")) {
      return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/sourceFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sourceFormFilter'.` };
    }
    const parsed_sourceFormFilter = ((): ParserResult<string[]> => {
      return ((value: unknown): ParserResult<string[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/sourceFormFilter]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/SummaryFiltersForm/sourceFormFilter]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryFiltersForm/sourceFormFilter]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["sourceFormFilter"]);
    })();
    if (!parsed_sourceFormFilter.success) {
      return { success: false, reason: parsed_sourceFormFilter.reason };
    }
    return {
      success: true,
      value: {
        audioFormFilter: parsed_audioFormFilter.value,
        languageFormFilter: parsed_languageFormFilter.value,
        miabFormFilter: parsed_miabFormFilter.value,
        publicationDateFormFilter: parsed_publicationDateFormFilter.value,
        qualityFormFilter: parsed_qualityFormFilter.value,
        ratingFormFilter: parsed_ratingFormFilter.value,
        sourceFormFilter: parsed_sourceFormFilter.value,
      },
    };
  })(value);
}
export function deserialize_SummaryFiltersForm(str: string): ParserResult<SummaryFiltersForm> {
  return deserialize_SummaryFiltersForm_internal(parseJsonWithNumbersAsBigint(str));
}
